/* global $ */
import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth.module'
import properties from './properties.module'
import cities from './cities.module'
import areas from './areas.module'
import restaurants from './restaurants.module'
import { getUserIpInfo } from '@/services/geoCurrency.service'

Vue.use(Vuex)

const state = {
  isInitialized: false,
  geoInfo: null,
  isGeoInfoInitialized: false,
}

// action types
export const INITIALIZE_PAGE = 'initializePage'
export const INITIALIZE_GEO_INFO = 'initializeGeoInfo'

// mutation types
export const SET_INITIALIZED = 'setInitialized'
export const SET_GEO_INFO = 'setGeoInfo'
export const SET_GEO_INFO_INITIALIZED = 'setGeoInfoInitialized'

const getters = {
  isInitialized(state) {
    return state.isInitialized
  },
  geoInfo(state) {
    return state.geoInfo
  },
}

const actions = {
  [INITIALIZE_PAGE](context) {
    context.commit(SET_INITIALIZED)
  },
  async [INITIALIZE_GEO_INFO](context) {
    if (context.state.isGeoInfoInitialized) {
      return context.state.geoInfo
    }

    const geoInfo = await getUserIpInfo()
    context.commit(SET_GEO_INFO, geoInfo)
    context.commit(SET_GEO_INFO_INITIALIZED)
    return geoInfo
  },
}

const mutations = {
  [SET_INITIALIZED](state) {
    state.isInitialized = true
    this._vm.$loadScript('/js/main.js').then(() => {
      $('[data-loader="circle-side"]').fadeOut() // will first fade out the loading animation
      $('#preloader').delay(350).fadeOut('slow') // will fade out the white DIV that covers the website.
      $('body').delay(350)
      $('.hero_in h1,.hero_in form').addClass('animated')
      $('.hero_single, .hero_in').addClass('start_bg_zoom')
      $(window).scroll()
    })
  },
  [SET_GEO_INFO](state, geoInfo) {
    state.geoInfo = geoInfo || null
  },
  [SET_GEO_INFO_INITIALIZED](state) {
    state.isGeoInfoInitialized = true
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    auth,
    properties,
    cities,
    areas,
    restaurants,
  },
})
